import { ReactNode } from "react";

interface PreviewPageCardProps {
	pageLabel: string;
	previewWidth: number;
	children: ReactNode;
}

export const PreviewPageCard: React.FC<PreviewPageCardProps> = ({ pageLabel, previewWidth, children }) => {
	return (
		<div className="mx-auto" style={{ width: previewWidth }}>
			<p className="text-xs text-gray-500 mb-1 font-medium">{pageLabel}</p>
			<div className="rounded shadow-sm border border-gray-200 bg-white" style={{ width: previewWidth, overflow: "hidden" }}>
				{children}
			</div>
		</div>
	);
};
